module.exports = __webpack_public_path__ + "img/kalli.dca556be.png";